import {Button, Modal} from "react-bootstrap";
import React from "react";
import useRecaptcha from "../useRecaptcha";
import ReCAPTCHA from "react-google-recaptcha";

function RecaptchaPopup(props) {
  const { captchaToken, recaptchaRef, handleRecaptcha} = useRecaptcha(props);
  const handleClose = () => {
    console.log("props",props);
    if(props.inputValues.isRecaptchaV2Verified){
      props.handleChangeValue("showRecaptchaPopup",false);
    }
  };


  return (
    <>
      <Modal
        show={props.inputValues.showRecaptchaPopup}


        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <Modal.Header closeButton>
          </Modal.Header>

        <Modal.Body>
          {/*{recaptchaRef.current}*/}
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6LfXOIwrAAAAAIwUn632roR-A9ceKS-mt4FNHJ2-"
            onChange={handleRecaptcha}

          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RecaptchaPopup;
